import React, { useEffect, useState } from 'react';
import { formattedMoney } from '../../helpers/utilities';
const YarnOptions = ({ currentVariant, allVariants, selectYarn, openYarnModal }) => {
    var _a, _b;
    const [yarnItems, setYarnItems] = useState([]);
    const [yarnPrices, setYarnPrices] = useState([]);
    const [isPreorder] = useState((_b = (_a = currentVariant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours) === null || _b === void 0 ? void 0 : _b.every((colour) => colour.swatches.every((swatch) => swatch.preorder_message)));
    useEffect(() => {
        const currentSize = currentVariant.options[0];
        const currentYarnOptions = allVariants.filter((variant) => variant.options.includes(currentSize));
        const currentPrices = currentYarnOptions.map((yarn) => {
            let price = yarn.price;
            yarn.yarn_group.yarn_colours.forEach((colour) => {
                price += (colour === null || colour === void 0 ? void 0 : colour.swatches[0].price) * (colour === null || colour === void 0 ? void 0 : colour.quantity);
            });
            return price;
        });
        setYarnItems(currentYarnOptions);
        setYarnPrices(currentPrices);
    }, [currentVariant]);
    if (!yarnItems.length)
        return null;
    return (React.createElement(React.Fragment, null, yarnItems.map((yarnItem, index) => (React.createElement("div", { className: `yarn-option ${currentVariant.yarn_group.yarn_info.name === yarnItem.yarn_group.yarn_info.name ? 'yarn-option--active' : ''}`, key: yarnItem.yarn_group.yarn_info.name },
        React.createElement("div", { className: "yarn-option__tag-wrapper" },
            React.createElement("button", { className: "yarn-option__info-btn", onClick: () => openYarnModal(index) }, "?"),
            yarnPrices[index] > yarnPrices[0] ? (React.createElement("div", { className: "yarn-option__surcharge" },
                "Premium ",
                React.createElement("span", null,
                    "+",
                    formattedMoney(yarnPrices[index] - yarnPrices[0])))) : null),
        React.createElement("img", { src: yarnItem.yarn_group.yarn_info.icon, alt: yarnItem.yarn_group.yarn_info.name, onClick: () => selectYarn(yarnItem) }),
        React.createElement("button", { className: "yarn-option__select-btn", onClick: () => selectYarn(yarnItem) }, yarnItem.yarn_group.yarn_info.name),
        React.createElement("div", { className: "yarn-option__preorder-message" }, yarnItem.preorder_message ? yarnItem.preorder_message : null))))));
};
export default YarnOptions;
